import { render, staticRenderFns } from "./ZonesServicesMapping.vue?vue&type=template&id=5c683eac&scoped=true&"
import script from "./ZonesServicesMapping.vue?vue&type=script&lang=js&"
export * from "./ZonesServicesMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c683eac",
  null
  
)

export default component.exports